import localStorageStore from '../store/LocalStorageStore';
import { WEvent } from '../websocket/events/WEvent';
import { WEventType } from '../websocket/events/WEventType';
import { isProduction } from './production.utils';

class Logger {
  private isDebug = localStorageStore.isDebug();

  public logWEvent = (eventType: WEventType, event: WEvent): void => {
    if (!isProduction() || this.isDebug) {
      // eslint-disable-next-line no-console
      console.log(eventType, event);
    }
  };

  public log = (...message: any[]): void => {
    if (!isProduction() || this.isDebug) {
      // eslint-disable-next-line no-console
      console.log(...message);
    }
  };
}

const logger = new Logger();
export default logger;
